module.exports = __webpack_public_path__ + "img/login-r-logo.ba5382a3.png";